<template>
  <div style="width: 100%;">
    <div style="margin-top: 0; margin-bottom: 24px; font-size: 32px; font-weight: bold">
      Конечно, это не&nbsp;будет использовано против меня
    </div>
    <div style="height: 100%; width: 100%; background-color: white; font-size: 12px; font-family: Monospaced,monospace; font-weight: bold; position: relative;" ref="qr">

      <div :style="style" :key="'b'">
        <div v-for="(i, index) in rqr" :key="index" style="color: darkgreen;">
          <template v-if="i">
            <!--            <div style="width: 100%; height: 100%; color: white; background-color: black" />-->
            <div :key="index+10000" style="line-height: 9px;">{{symbol()}}</div>
          </template>
          <template v-else>

          </template>
        </div>
      </div>

      <transition mode="out-in" name="fade">
        <div v-if="bw" :style="style" :key="'a'" style="position: absolute; left: 0px; top: 0; width: 100%; background-color: white">
          <div v-for="(i, index) in rqr" :key="index" style="color: white;">
            <template v-if="i">
              <!--            <div style="width: 100%; height: 100%; color: white; background-color: black" />-->
              <div :key="index+20000" style="width: 100%; height: 100%; color: white; background-color: black"/>
            </template>
            <template v-else>

            </template>
          </div>
        </div>
      </transition>
    </div>
    <div style="margin-top: 20px; font-size: 16px; text-align: center;">
      разрешение на свободу
    </div>
    <transition name="fade">
    <div v-if="words"  style="margin-top: 64px;">
      Обращение
      <br><br>
      Желание процветать - это прекрасное желание. Любое живое существо волнует его здоровье. Меня тоже.
      <br><br>
      Эти темы для сертификатов вакцинации затрагивают тему свободы. Я хочу, чтобы каждый человек осознавал, что отдает кусочек
      своей свободы взамен на ощущение безопасности и защищенности. Я хочу, чтобы мы делились свободой не из
      парализующего страха, а из выбора, принятого ясным умом.
      <br><br>
      Я хочу, чтобы мы урезали свою свободу на короткое время и затем вернули её обратно. Я&nbsp;верю, что мир без лжи,
      обмана, насилия и злобы возможен без жёсткой слежки, наказаний и ограничений свобод. <br><br>Дагни Таггерт.
    </div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable no-console */
import QRCode from 'qrcode'

export default {
  name: "QR",
  data() {
    return {
      url: "https://www.gosuslugi.ru/vaccine/cert/verify/f66cdcea-83e1-44c2-b7ac-5209b9b910f9",
      bw: false, rqr: null, counter: 10, words: false,
      width: 400,
    };
  },
  computed: {
    qr() {
      let code = QRCode.create(this.url);
      console.log(code);
      // console.log(code.data);
      // eslint-disable-next-line no-console
      // code.data.forEach(it => console.log(it));
      return code.modules;
    },
    style() {
      return `display: grid; grid-template-columns: repeat(${this.qr.size}, ${this.width / this.qr.size}px); grid-template-rows: repeat(${this.qr.size}, ${this.width / this.qr.size}px);`;
    }
  },
  created() {
    // this.$nextTick();
    setTimeout(() => {
      this.bw = true;
    }, 500);

    setTimeout(() => {
      this.words = true;
    }, 3500);


    setTimeout(() => {
      this.randQR();
    }, 1);
  },
  mounted() {
    this.width = this.$refs.qr.clientWidth;
  },
  methods: {
    randQR() {
      if (this.bw && this.counter===0) {
        this.rqr= this.qr.data;
        return
      }
      if (this.bw) this.counter--;

      let rqr = new Uint8Array(this.qr.data);
      let size = this.qr.size;

      for (var i = 0; i < 50; i++ ) {
        rqr[Math.floor(Math.random() * size* size)] = 0;
        rqr[Math.floor(Math.random() * size* size)] = 1;
      }
      this.rqr = rqr;

      setTimeout(() => {
        this.randQR();
      }, 100);
    },
    symbol() {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ!@#$%^&*()_<>/:\\0123456789';  //abcdefghijklmnopqrstuvwxyz
      var charactersLength = characters.length;

        result = characters.charAt(Math.floor(Math.random() * charactersLength));
        return result;
    },
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 1.0s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
